import ListFooter from './ListFooter';

export default ListFooter;
